export default {
  header: "Alerts",
  markRead: "Mark Read",
  noAlerts: "You have no alerts.",
  preferences: "Preferences"
};
